module.exports = __webpack_public_path__ + "static/secure-f24fddbd80122ba4cceb02dac2c9b39b.svg";